import { render, staticRenderFns } from "./MultipleChoice.vue?vue&type=template&id=d1b86aca&scoped=true"
import script from "./MultipleChoice.vue?vue&type=script&lang=js"
export * from "./MultipleChoice.vue?vue&type=script&lang=js"
import style0 from "./MultipleChoice.vue?vue&type=style&index=0&id=d1b86aca&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d1b86aca",
  null
  
)

export default component.exports